import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Colors from "../../../../assets/styles/Colors";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "../../../../store";
import { TranslationsField } from "../../../../domain/types";
import { useTranslation } from "react-i18next";
import api from "../../../../api";
import Loader from "../../../../components/Loader";
import CustomSelect from "../../../../components/CustomSelect";
import AdminLangSwicher from "../../../admin_components/AdminLangSwicher";
import { AppState } from "../../../../store/appSlice";

const AdminCriticalManagePages = () => {
  //
  const navigate = useNavigate();
  //
  const { lang } = useAppSelector((root) => root.app);
  //
  const { field_Language } = useAppSelector(
    (data: { app: AppState }) => data.app
  );
   //
  const { t } = useTranslation();
  //
  // page slugs
  const pageSlugs: {
    id: number;
    slug: string;
    text: string;
    translations: TranslationsField<{ text: string }>;
  }[] = [
    {
      id: 1,
      slug: "critical-insurance-period",
      text: "სადაზღვევო პერიოდი",
      translations: {
        en: {
          text: "Insurance period",
        },
        ge: {
          text: "სადაზღვევო პერიოდი",
        },
      },
    },
    {
      id: 2,
      slug: "critical-select-currency-limit",
      text: "ვალუტა / ლიმიტი",
      translations: {
        en: {
          text: "Currency / Limit",
        },
        ge: {
          text: "ვალუტა / ლიმიტი",
        },
      },
    },
    {
      id: 3,
      slug: "critical-age-of-insured",
      text: "დაზღვეულის ასაკი",
      translations: {
        en: {
          text: "How old is Insured",
        },
        ge: {
          text: "დაზღვეულის ასაკი",
        },
      },
    },
    {
      id: 4,
      slug: "critical-trust-us-or-yourself",
      text: "შეთავაზების ტიპი",
      translations: {
        en: {
          text: "Offer type",
        },
        ge: {
          text: "შეთავაზების ტიპი",
        },
      },
    },
    {
      id: 5,
      slug: "critical-which-offer",
      text: "შეთავაზებები",
      translations: {
        en: {
          text: "Offers",
        },
        ge: {
          text: "შეთავაზებები",
        },
      },
    },
    {
      id: 6,
      slug: "critical-best-offer",
      text: "საუკეთესო შეთავაზება",
      translations: {
        en: {
          text: "Best offer",
        },
        ge: {
          text: "საუკეთესო შეთავაზება",
        },
      },
    },
    {
      id: 7,
      slug: "critical-insurance-for-who",
      text: "ვისთვის ყიდულობ დაზღვევას",
      translations: {
        en: {
          text: "Who do you buy insurance for",
        },
        ge: {
          text: "ვისთვის ყიდულობ დაზღვევას",
        },
      },
    },
    {
      id: 8,
      slug: "critical-your-personal-info",
      text: "დამზღვევის ინფორმაცია",
      translations: {
        en: {
          text: "Insurer's information",
        },
        ge: {
          text: "დამზღვევის ინფორმაცია",
        },
      },
    },
    {
      id: 9,
      slug: "critical-insured-personal-info",
      text: "დაზღვეულის ინფორმაცია",
      translations: {
        en: {
          text: "Insured's information",
        },
        ge: {
          text: "დაზღვეულის ინფორმაცია",
        },
      },
    },
    {
      id: 10,
      slug: "critical-check-info",
      text: "ინფორმაციის გადამოწმება",
      translations: {
        en: {
          text: "Check information",
        },
        ge: {
          text: "ინფორმაციის გადამოწმებ",
        },
      },
    },
    {
      id: 11,
      slug: "critical-your-contact-info",
      text: "საკონტაქტო ინფორმაცია",
      translations: {
        en: {
          text: "Contact info",
        },
        ge: {
          text: "საკონტაქტო ინფორმაცია",
        },
      },
    },
  ];
  //
  // selected slug
  const [selectedSlug, setSelectedSlug] = useState<string | null>(null);
  //
  // get critical flow
  const { data: pageTextArray, isLoading: isPageTextArrayLoading, refetch: refetchPageTextArray } =
    api.useGetTplFlowPageTextsBySlugQuery(selectedSlug as string, {
      skip: !selectedSlug && true,
    });
  //
  //
  useEffect(() => {
    if(pageTextArray){
      refetchPageTextArray()
    }
  }, [refetchPageTextArray, pageTextArray])
  //
  const MainLoading = isPageTextArrayLoading;
  //
  return MainLoading ? (
    <Loader />
  ) : (
    <Wrapper>
      <CustomSelect
        defaultInputValue={
          pageSlugs.find((x) => x.slug === selectedSlug)?.text || ""
        }
        placeholder=""
        headText={t("choosePage")}
        onChange={(event) => setSelectedSlug(event.value)}
        data={[
          ...pageSlugs.map((item) => ({
            value: item.slug,
            label: item?.translations?.[lang]?.text,
          })),
        ]}
      />
      {pageTextArray && (
        <InfoBlock>
          <div>
            <AdminLangSwicher />
          </div>
          {/*  */}
          <Content>
            {pageTextArray?.translations && (
              <InnerBox
                onClick={() =>
                  navigate(`/manage-critical-pages-edit/${selectedSlug}`)
                }
                style={{ cursor: "pointer" }}
              >
                {pageTextArray?.translations?.[field_Language]?.title && (
                  <>
                    <div style={{ color: Colors.primaryRed }}>{t("title")}</div>
                    <TextBlock>
                      {pageTextArray?.translations[field_Language]?.title}
                    </TextBlock>
                  </>
                )}

                {pageTextArray?.translations?.[field_Language]?.stepName && (
                  <>
                    <div style={{ color: Colors.primaryRed }}>
                      {t("stepName")}
                    </div>
                    <TextBlock>
                      {pageTextArray?.translations[field_Language]?.stepName}
                    </TextBlock>
                  </>
                )}
              </InnerBox>
            )}
            {pageTextArray &&
              pageTextArray?.listItems?.map((item, index) => (
                <InnerBox
                  key={index}
                  onClick={() =>
                    navigate(
                      `/manage-critical-pages-edit/${selectedSlug}/${item?.id}`
                    )
                  }
                  style={{ cursor: "pointer" }}
                >
                  {item?.translations?.[field_Language]?.title && (
                    <>
                      <div style={{ color: Colors.primaryRed }}>
                        {t("title")}
                      </div>
                      <TextBlock>
                        {item?.translations[field_Language]?.title}
                      </TextBlock>
                    </>
                  )}
                  {item?.translations?.[field_Language]?.body && (
                    <>
                      <div style={{ color: Colors.primaryRed }}>
                        {t("body")}
                      </div>
                      <TextBlock>
                        {item?.translations[field_Language]?.body}
                      </TextBlock>
                    </>
                  )}
                  {item?.translations?.[field_Language]?.excerpt && (
                    <>
                      <div style={{ color: Colors.primaryRed }}>
                        {t("additionalInformation")}
                      </div>
                      <TextBlock>
                        {item?.translations[field_Language]?.excerpt}
                      </TextBlock>
                    </>
                  )}

                  {item?.translations?.[field_Language]?.secondTitle && (
                    <>
                      <div style={{ color: Colors.primaryRed }}>
                        {t("secondTitle")}
                      </div>
                      <TextBlock>
                        {item?.translations[field_Language]?.secondTitle}
                      </TextBlock>
                    </>
                  )}

                  {item?.translations?.[field_Language]?.secondExcerpt && (
                    <>
                      <div style={{ color: Colors.primaryRed }}>
                        {t("secondAdditionalInformation")}
                      </div>
                      <TextBlock>
                        {item?.translations[field_Language]?.secondExcerpt}
                      </TextBlock>
                    </>
                  )}

                  {item?.translations?.[field_Language]?.thirdTitle && (
                    <>
                      <div style={{ color: Colors.primaryRed }}>
                        {t("thirdTitle")}
                      </div>
                      <TextBlock>
                        {item?.translations[field_Language]?.thirdTitle}
                      </TextBlock>
                    </>
                  )}

                  {item?.translations?.[field_Language]?.thirdExcerpt && (
                    <>
                      <div style={{ color: Colors.primaryRed }}>
                        {t("thirdAdditionalInformation")}
                      </div>
                      <TextBlock>
                        {item?.translations[field_Language]?.thirdExcerpt}
                      </TextBlock>
                    </>
                  )}
                  <ImageStyle src={item?.image} alt="" />
                </InnerBox>
              ))}
          </Content>
          {/*  */}
        </InfoBlock>
      )}
    </Wrapper>
  );
};
//
// styles
const ImageStyle = styled.img`
  height: 100px;
  width: fit-content;
  margin-inline: auto;
`;
const TextBlock = styled.div`
  border-bottom: 1px dashed ${Colors.primaryRed};
  margin-bottom: 10px;
  padding-block: 5px;
`;
const Content = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 20px;
  margin-top: 20px;
`;
const InnerBox = styled.div`
  border: 1px solid ${Colors.primaryRed};
  border-radius: 4px;
  padding: 5px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;
const InfoBlock = styled.div`
  margin-top: 30px;
  box-shadow: 0px 1px 12px 1px rgba(118, 131, 139, 0.23);
  -webkit-box-shadow: 0px 1px 12px 1px rgba(118, 131, 139, 0.23);
  -moz-box-shadow: 0px 1px 12px 1px rgba(118, 131, 139, 0.23);
  border-radius: 4px;
  background-color: ${Colors.grey};
  padding: 20px;
  color: ${Colors.primaryGrey};
  /*  */
  a {
    &:last-child {
      color: ${Colors.secondaryRed};
      text-decoration-color: ${Colors.primaryRed};
    }
  }
`;
const Wrapper = styled.div``;
export default AdminCriticalManagePages;
